<template>
  <div id="app">
    <el-dialog :visible.sync="messageShow">
      <Message :rkey="Math.random()"></Message>
    </el-dialog>
    <el-container>
      <el-header class="top-line">
        <el-row>
          <el-col :span="24" v-if="!if_login" style="text-align:center">
            <span style="line-height: 60px;font-size:32px;">考务信息辅助管理平台</span>
          </el-col>
          <el-col :span="12" v-if="if_login" style="padding-left: 180px !important;">
            <div>
              <el-menu
                :default-active="default_active"
                class="el-menu-demo"
                mode="horizontal"
                background-color="#0099FF"
                text-color="#FFFFFF"
                active-text-color="#CCFF66"
                @select="handleSelect"
              >
                <el-menu-item index="xxcj" v-if="user.main_menu.indexOf('xxcj')>-1">考试项目</el-menu-item>
                <el-menu-item index="xmgl" v-if="user.main_menu.indexOf('xmgl')>-1">项目管理</el-menu-item>
              </el-menu>
            </div>
          </el-col>
          <el-col :span="12" v-if="if_login" style="text-align:right">
            <span style="line-height: 60px;">欢迎：{{user.name}}({{user_area}})&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <el-button-group>
              <el-button icon="el-icon-ali-jiaoseguanli" type="primary" plain @click="resetPass"></el-button>
              <el-button icon="el-icon-ali-icon_log-out" type="primary" plain @click="login"></el-button>
              <!-- <el-tooltip content="获取帮助文档" v-if="user.help_url">
                <el-button icon="el-icon-ali-jiufuqianbaoicon09" type="primary" plain @click="help"></el-button>
              </el-tooltip>
              <el-badge :value="messageCount" :type="messageCount>0?'danger':'info'">
                <el-tooltip content="站内通知">
                  <el-button
                    icon="el-icon-ali-xiaoxi"
                    type="primary"
                    plain
                    style="border-left:none"
                    @click="messageShow = true"
                  ></el-button>
                </el-tooltip>
              </el-badge> -->
            </el-button-group>
          </el-col>
        </el-row>
      </el-header>
      <router-view style="position:absolute;bottom:45px;top:60px;width: 100%;" class="main"></router-view>
      <el-footer
        height="45px"
        style="position:absolute;bottom:0;background-color:#0099FF;color: #FFFFFF;width:100%;"
      >
        <el-row type="flex" justify="center" style="line-height:44px;">
          <el-col :span="8" :offset="8">
            <el-link
              href="http://www.guandingyun.com/"
              target="_blank"
              style="color:white;"
            >常州美拓信息技术有限公司</el-link>
          </el-col>
          <el-col :span="8" style="text-align:right;font-size:12px;">
            <span>Ver:20250901</span>
          </el-col>
        </el-row>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import global_ from "./global";
import Message from "./views/components/Message";


const api_for_vue = global_.api_user;

export default {
  name: "app",
  components: { Message },
  created() {
    let checkMessage = () => {
      if (this.if_login) {
        let _params = {
          servicename: "get_message_count"
        };
        this.axios
          .get(api_for_vue, {
            params: _params
          })
          .then(response => {
            this.messageCount = response.data.resultinfo;
          })
          .catch(error => {
            if (error.response.status === 401) {
              this.$router.push("/login");
            } else {
              this.$message.error("服务器开小差了");
            }
          });
      }
    };
    checkMessage();
    // this.intervalId = setInterval(() => {
    //   checkMessage();
    // }, 60000);
  },
  beforeDestroy() {
    // clearInterval(this.intervalId);
  },
  data() {
    return {
      intervalId: 0,
      editShow: false,
      messageShow: false,
      messageCount: 0
    };
  },
  computed: {
    if_login() {
      return this.$store.state.if_login;
    },
    user() {
      return this.$store.state.user;
    },
    default_active() {
      return this.$store.state.default_active;
    },
    user_area() {
      let _level = this.$store.state.user.level;
      let _user_area = "";
      switch (_level) {
        case "地市":
          _user_area = this.$store.state.user.city;
          break;
        case "区县":
          _user_area = this.$store.state.user.area;
          break;
        case "学校":
          _user_area = this.$store.state.user.school;
          break;
      }
      return _user_area;
    }
  },
  methods: {
    login() {
      this.$store.state.if_login = !this.$store.state.if_login;
      let data = new FormData();
      data.append("servicename", "logout");
      this.axios
        .post(api_for_vue, data)
        .then(response => {
          this.$store.state.user = response.data.resultinfo;
          this.$store.commit("logout");
          this.$router.replace("/login");
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.$message.error("认证失败");
          } else {
            this.$message.error("服务器开小差了");
          }
        });
    },
    resetPass() {
      this.$router.push("/reset");
    },
    help() {
      window.open(this.user.help_url, "_blank");
    },

    handleSelect(key) {
      if (key === "xxcj") {
        this.$router.push("/xxcj/list");
      } else if (key === "xmgl") {
        this.$router.push("/xmgl");
      } else if (key === "admin") {
        this.$router.push("/admin");
      }
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: block;
}
.top-line {
  text-align: center;
  background-image: url("./assets/logo.png");
  background-repeat: no-repeat;
  background-size: contain;
  height: 60px;
  background-position: 0 0;
  background-color: #0099ff;
  color: #ffffff;
}
.logo {
  background-image: url("./assets/logo.png");
}
</style>
